<p-toast></p-toast>
<div class="grid">
  <div class="col-12">
    <div class="card dashboardTable">
      <p-toolbar styleClass="mb-4" reflow="true">
        <ng-template pTemplate="left">
          <!-- <button pButton pRipple label="{{'ADD_LAND_DETAILS'| translate}}" icon="pi pi-plus"
            class="p-button-success mr-2" (click)="openNew()"></button> -->
          <button pButton pRipple label="{{'FETCH_DETAILS_FROM_JAMABANDI'| translate}}" icon="pi pi-plus"
            class="p-button-success mr-2" (click)="onClickJamabandi()"></button>
        </ng-template>

        <ng-template pTemplate="right">
          <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
            class="p-button-help"></button>
          <p-menu #menu [popup]="true" [model]="items"></p-menu>
        </ng-template>
      </p-toolbar>

      <p-table #dt [value]="lstFarmerLandModel" [rows]="10" [paginator]="true"
        [globalFilterFields]="['Land_ID','Total_Area','Morabba_No','Killa_No','VillageName', 'OwnerName', 'Bhag', 'Khewat', 'Year', 'Mode', 'OwnerHissa', 'KhewatArea']"
        [(selection)]="selectedFarmerLand" [rowHover]="true" dataKey="id"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true" [loading]="loading1" responsiveLayout="scroll">

        <ng-template pTemplate="caption">
          <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 class="m-0">{{'MANAGE_LAND_DETAILS'| translate}}</h5>
            <span class="block mt-2 md:mt-0 p-input-icon-left">
              <i class="pi pi-search"></i>
              <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                placeholder="{{'SEARCH'| translate}}" />
            </span>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <!-- <th style="width: 2rem">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th> -->
            <th pSortableColumn="Mode">{{'MODE'| translate}}</th>
            <th pSortableColumn="Land_ID">{{'LAND_ID'| translate}}</th>
            <th pSortableColumn="VillageName">{{'VILLAGE'| translate}}</th>
            <th pSortableColumn="KhewatArea">{{'KHEWAT_AREA'| translate}}</th>
            <th pSortableColumn="OwnerName">{{'OWNER_NAME'| translate}}</th>
            <th pSortableColumn="OwnerHissa">{{'OWNER_HISSA_IN_ACRES'| translate}}</th>

            <th pSortableColumn="Khewat">{{'KHEWAT'| translate}}</th>
            <th pSortableColumn="Bhag">{{'BHAG'| translate}}</th>

            <th pSortableColumn="Morabba_No">{{'MORABBA_NUMBER'| translate}}</th>
            <th pSortableColumn="Killa_No">{{'KILLA_NUMBER'| translate}}</th>
            <th pSortableColumn="Total_Area">{{'TOTAL_AREA'| translate}}</th>
            <th pSortableColumn="UnitDesc">{{'Unit'| translate}}</th>
            <th pSortableColumn="Year">{{'YEAR'| translate}}</th>
            <th>{{ 'ACTION' | translate }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
          <tr>
            <!-- <td>
              <p-tableCheckbox [value]="product"></p-tableCheckbox>
            </td> -->
            <td>{{product?.Mode}}</td>
            <td>{{product.Land_ID}}</td>
            <td>{{product.VillageName}}</td>
            <td>{{product.KhewatArea}}</td>
            <td>{{product?.OwnerName}}</td>
            <td>{{product?.OwnerHissa}}</td>
            <td>{{product?.Khewat}}</td>
            <td>{{product?.Bhag}}</td>
            <td>{{product.Morabba_No}}</td>
            <td>{{product.Killa_No}}</td>
            <td>{{product.Total_Area}}</td>
            <td>{{product.UnitDesc}}</td>
            <!-- <td>{{product.Kanals}}</td> -->
            <td>{{product.Year}}</td>
            <td>
              <div class="flex justify-content-between">
                <!-- <div *ngIf="product.IsEdit == 1">
                  <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"
                    (click)="editProduct(product)"></button>
                </div> -->
                <div *ngIf="product.IsDelete == 1">
                  <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning"
                    (click)="deleteProduct(product)"></button>
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between">
            {{'IN_TOTAL_THERE_ARE'| translate}} {{lstFarmerLandModel ? lstFarmerLandModel.length : 0 }}
            {{'LAND_DETAILS_ADDED'| translate}}.
          </div>
        </ng-template>
      </p-table>
    </div>

    <p-dialog [(visible)]="productDialog" (onHide)="hideDialog()"
      [style]="{width: innerWidth < 500 ?'400px' : '750px', height: '80vh'}" header="Land Details" [modal]="true"
      reflow="true" class="p-fluid" [baseZIndex]="-100" [draggable]="false">
      <ng-template pTemplate="content">
        <form [formGroup]="farmerLandForm">
          <div class="grid p-fluid mt-3">
            <div class="field col-12 md:col-4">
              <span class="p-float-label">
                <!-- <p-inputNumber [useGrouping]="false" inputId="morabbaNumber" class="form-control"
                  formControlName="morabbaNumber" autofocus="" tabindex="1"
                  [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.morabbaNumber.errors }"></p-inputNumber> -->
                <input pInputText inputId="morabbaNumber" type="text" class="form-control" [pKeyFilter]="blockSpace"
                  formControlName="morabbaNumber" autofocus="" tabindex="1"
                  [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.morabbaNumber.errors }" />
                <div *ngIf="submitted && f.morabbaNumber.errors" class="invalid-feedback">
                  <div *ngIf="f.morabbaNumber.errors.required">{{'MORABBA_NUMBER_IS_REQUIRED'| translate}}</div>
                </div>
                <label for="morabbaNumber">{{'MORABBA_NUMBER'| translate}}</label>
              </span>
            </div>
            <div class="field col-12 md:col-4">
              <span class="p-float-label">
                <!-- <p-inputNumber [useGrouping]="false" inputId="killaNumber" class="form-control"
                  formControlName="killaNumber" autofocus="" tabindex="1"
                  [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.killaNumber.errors }"></p-inputNumber> -->
                <input pInputText inputId="killaNumber" type="text" class="form-control" formControlName="killaNumber"
                  [pKeyFilter]="blockSpace" autofocus="" tabindex="1"
                  [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.killaNumber.errors }" />
                <div *ngIf="submitted && f.killaNumber.errors" class="invalid-feedback">
                  <div *ngIf="f.killaNumber.errors.required">{{'KILLA_NUMBER_IS_REQUIRED'| translate}}</div>
                </div>
                <label for="killaNumber">{{'KILLA_NUMBER'| translate}}</label>
              </span>
            </div>
            <div class="field col-12 md:col-4">
              <span class="p-float-label">
                <input readonly pInputText id="totalArea" class="form-control" type="text" formControlName="totalArea"
                  autofocus="" tabindex="1" [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.totalArea.errors }" />
                <div *ngIf="submitted && f.totalArea.errors" class="invalid-feedback">
                  <div *ngIf="f.totalArea.errors.required">{{'TOTAL_AREA_IS_REQUIRED'| translate}}</div>
                </div>
                <label for="totalArea">{{'TOTAL_AREA_IN_ACRE'| translate}}</label>
              </span>
            </div>

            <div class="field col-12 md:col-4">
              <span class="p-float-label">
                <input pInputText id="kanals" class="form-control" type="text" formControlName="kanals" autofocus=""
                  tabindex="1" [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.kanals.errors }"
                  (keyup)="onKanalsChange()" maxlength="1" pattern="^([0-1]?[0-8])$" pKeyFilter="int"
                  oninput="if(!this.value.match('^[0-8][0-8]*$'))this.value='';" />
                <div *ngIf="submitted && f.kanals.errors" class="invalid-feedback">
                  <div *ngIf="f.kanals.errors.required">{{'KANNALS_IS_REQUIRED'| translate}}</div>
                  <div *ngIf="f.kanals.errors.max">{{'KANAL_CANNOT_BE_GREATER'| translate}}.</div>
                </div>
                <label for="kanals">{{'AREA_IN_KANALS'| translate}}</label>
              </span>
            </div>
            <div class="field col-12 md:col-4">
              <span class="p-float-label">
                <input maxlength="2" pKeyFilter="int" pInputText id="marlas" class="form-control" type="text"
                  formControlName="marlas" autofocus="" tabindex="1"
                  [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.marlas.errors }" (keyup)="onMarlasChange()"
                  oninput="if(!this.value.match('^([0-9]|1[0-9])$'))this.value='';" />
                <div *ngIf="submitted && f.marlas.errors" class="invalid-feedback">
                  <div *ngIf="f.marlas.errors.required">{{'MARLAS_IS_REQUIRED'| translate}}</div>
                  <div *ngIf="f.marlas.errors.max">{{'MARLAS_SHOULD_NOT_BE_GREATER'| translate}}</div>
                </div>
                <label for="marlas">{{'AREA_IN_MARLAS'| translate}}</label>
              </span>
            </div>
            <!-- <div class="field col-12 md:col-4">
              <span class="p-float-label">
                <p-treeSelect formControlName="cropType" [(ngModel)]="selectedNodes1" [options]="nodes2" appendTo="body"
                  [metaKeySelection]="false" selectionMode="checkbox" placeholder="{{'SELECT_CROP_TYPE'| translate}}"></p-treeSelect>

                <div *ngIf="submitted && f.cropType.errors" class="invalid-feedback">
                  <div *ngIf="f.cropType.errors.required">{{'CROP_TYPE_IS_REQUIRED'| translate}}</div>
                </div>
              </span>
            </div> -->
            <div class="field col-12 md:col-4">
              <span class="p-float-label">
                <p-autoComplete formControlName="village" [(ngModel)]="selectedVillage"
                  placeholder="{{'SEARCH_VILLAGE' | translate}}" appendTo="body" id="dd" [dropdown]="true"
                  [multiple]="false" [suggestions]="filteredVillage" (completeMethod)="filterVillage($event)"
                  field="Name" [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.village.errors }"></p-autoComplete>

                <div *ngIf="submitted && f.village.errors" class="invalid-feedback">
                  <div *ngIf="f.village.errors.required">{{'VILLAGE_IS_REQUIRED'| translate}}</div>
                </div>
              </span>
            </div>
            <div class="field col-12 md:col-4">
              <span class="p-float-label">
                <!-- <p-treeSelect [propagateSelectionDown]="false" formControlName="cropType" [(ngModel)]="selectedNodes1" [options]="nodes2" appendTo="body"
                  [metaKeySelection]="true" selectionMode="checkbox"
                  placeholder="{{'SELECT_CROP_TYPE'| translate}}"></p-treeSelect> -->

                <p-multiSelect [showToggleAll]="false" [options]="cropMergeList" formControlName="cropType"
                  [maxSelectedLabels]="4" [selectedItemsLabel]="'{0} items selected'"
                  placeholder="{{'SELECT_CROP_TYPE'| translate}}" [(ngModel)]="selectedNodes1" optionLabel="label"
                  [virtualScroll]="true" [virtualScrollItemSize]="30" appendTo="body"
                  (onChange)="onCropSelect($event)"></p-multiSelect>

                <div *ngIf="selectedNodes1.length > 4" class="invalid-feedback">
                  <div>{{'MAXIMUM_4_CROP_IS_ALLOWED_YOU_SELECTED'| translate}} {{ selectedNodes1.length }}</div>
                </div>
                <div *ngIf="submitted && f.cropType.errors" class="invalid-feedback">
                  <div *ngIf="f.cropType.errors.required">{{'CROP_TYPE_IS_REQUIRED'| translate}}</div>
                </div>
              </span>
            </div>

            <div class="field col-12 md:col-4">
              <span class="p-float-label">
                <input pInputText id="latitude" class="form-control" type="text" formControlName="latitude" autofocus=""
                  tabindex="1" [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.latitude.errors }" />
                <div *ngIf="submitted && f.latitude.errors" class="invalid-feedback">
                  <div *ngIf="f.latitude.errors.required">{{'LATITUDE_IS_REQUIRED'| translate}}</div>
                </div>
                <label for="latitude">{{'LATITUDE'| translate}} </label>
              </span>
            </div>
            <div class="field col-12 md:col-4">
              <span class="p-float-label">
                <input pInputText id="longitude" class="form-control" type="text" formControlName="longitude"
                  autofocus="" tabindex="1" [ngClass]="{ 'ng-invalid ng-dirty': submitted && f.longitude.errors }" />
                <div *ngIf="submitted && f.longitude.errors" class="invalid-feedback">
                  <div *ngIf="f.longitude.errors.required">{{'LONGITUDE_IS_REQUIRED'| translate}}</div>
                </div>
                <label for="longitude ">{{'LONGITUDE'| translate}} </label>
              </span>
              <p class="text-message" (click)="setCurrentPosition()">{{'FIND_MY_CURRENT_LOCATION'| translate}}</p>
            </div>

            <!-- <div class="field  col-12 md:col-4">
              <label class="mb-3">{{'LEASE_LAND'| translate}}</label>
              <div class="formgrid grid">
                <div class="field-radiobutton col-4">
                  <p-radioButton name="IsSubsidyAvailabe" [value]="true" [(ngModel)]="valRadio"
                    formControlName="IsSubsidyAvailabe" id="IsSubsidyAvailabeYes">
                  </p-radioButton>
                  <label for="IsSubsidyAvailabeYes">{{'YES'| translate}}</label>
                </div>
                <div class="field-radiobutton col-8">
                  <p-radioButton name="IsSubsidyAvailabe" [value]="false" [(ngModel)]="valRadio"
                    formControlName="IsSubsidyAvailabe" id="IsSubsidyAvailabeNo">
                  </p-radioButton>
                  <label for="IsSubsidyAvailabeNo">{{'NO'| translate}}</label>
                </div>
              </div>
              <div *ngIf="submitted && f.IsSubsidyAvailabe.errors" class="invalid-feedback">
                <div *ngIf="f.IsSubsidyAvailabe.errors.required">{{'LEASE_LAND_IS_REQUIRED'| translate}}</div>
              </div>
            </div> -->

            <!-- <div class="field col-12 md:col-4">

            </div> -->
            <!-- <div class="field col-12 md:col-4">
              <div class="flex">
                <button pButton pRipple type="button" label="Find my current location"
                  class="p-button-outlined mr-2 mb-2" (click)="setCurrentPosition()">

                </button>
              </div>
            </div> -->
            <!-- <div class="field col-12 md:col-4">
              <div class="flex">
                <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true" #farmerLandLocUpload
                  (uploadHandler)="onUpload($event, 'landdoc_Path', farmerLandLocUpload)" name="myfile[]" mode="basic"
                  [maxFileSize]="5000000" chooseLabel="{{'UPLOAD_DOCUMENTS'| translate}}" [auto]="true">
                </p-fileUpload>
                <p-image *ngIf="f.landdoc_Path.value" [src]="f.landdoc_Path.value" alt="Image" width="60" class="ml-2"
                  iconPos="left"></p-image>
              </div>
              <div *ngIf="submitted && f.landdoc_Path.errors" class="invalid-feedback">
                <div *ngIf="f.landdoc_Path.errors.required">{{'LAND_DOCUMENT_IS_REQUIRED'| translate}}</div>
              </div>
            </div> -->
            <!-- <div class="field col-12 md:col-4" *ngIf="valRadio">
              <div class="flex">
                <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true" #farmerLeaseDocUpload
                  (uploadHandler)="onUpload($event, 'leaseDoc_Path', farmerLeaseDocUpload)" name="myfile[]" mode="basic"
                  [maxFileSize]="5000000" chooseLabel="{{'UPLOAD_LEASE_DOCUMENTS'| translate}}" [auto]="true">
                </p-fileUpload>
                <p-image *ngIf="f.leaseDoc_Path.value" [src]="f.leaseDoc_Path.value" alt="Image" width="60" class="ml-2"
                  iconPos="left"></p-image>
              </div>
            </div> -->
          </div>
        </form>
      </ng-template>

      <ng-template pTemplate="footer">
        <button pButton pRipple label="{{'CANCEL'| translate}}" icon="pi pi-times" class="p-button-text"
          (click)="hideDialog()"></button>
        <button pButton pRipple label="{{'SAVE' | translate}}" icon="pi pi-check" class="p-button-text"
          (click)="onSubmit()"></button>
      </ng-template>
    </p-dialog>

    <p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>
  </div>
</div>


<p-dialog [(visible)]="openJamabandiDialog" (onHide)="hideDialogJamaBandi()" [style]="{width: '90vw', height: '80vh'}"
  header="Land Details from Jamabandi" [modal]="true" reflow="true" class="p-fluid" [baseZIndex]="-101"
  [draggable]="false">
  <ng-template pTemplate="content">
    <form [formGroup]="jamabandiLandForm">
      <div class="grid p-fluid mt-3 jamabandi-form-card">
        <div class="field col-12 md:col-4">
          <span class="p-float-label">
            <p-autoComplete formControlName="village" [ngModelOptions]="{standalone: true}"
              [(ngModel)]="selectedVillage" [disabled]="showHiddenButton" placeholder="{{'SEARCH_VILLAGE' | translate}}"
              appendTo="body" id="dd" [dropdown]="true" [multiple]="false" [suggestions]="filteredVillage"
              (completeMethod)="filterVillage($event)" field="Name"
              [ngClass]="{ 'ng-invalid ng-dirty': submittedJambandi && f1.village.errors }"></p-autoComplete>

            <div *ngIf="submittedJambandi && f1.village.errors" class="invalid-feedback">
              <div *ngIf="f1.village.errors.required">{{'VILLAGE_IS_REQUIRED'| translate}}</div>
            </div>
          </span>
        </div>

        <div class="field col-12 md:col-4">
          <span class="p-float-label">
            <input pInputText inputId="khewatNo" type="text" class="form-control" [pKeyFilter]="blockSpace"
              [readOnly]="showHiddenButton" formControlName="khewatNo" autofocus=""
              [ngClass]="{ 'ng-invalid ng-dirty': submittedJambandi && f1.khewatNo.errors }" />
            <div *ngIf="submittedJambandi && f1.khewatNo.errors" class="invalid-feedback">
              <div *ngIf="f1.khewatNo.errors.required">{{'KHEWAT_NUMBER_IS_REQUIRED'| translate}}</div>
            </div>
            <label for="khewatNo">{{'KHEWAT_NUMBER'| translate}}</label>
          </span>
        </div>

        <div class="field col-12 md:col-3">
          <div *ngIf="!(showHiddenButton)" class="d-flex justify-content-center align-items-center vh-100">
            <button (click)="onClickGetOwnerDetails()" pButton pRipple label="{{ 'Get Owner Detail' | translate }}"
              class="p-button-success"></button>
          </div>

          <div *ngIf="showHiddenButton" class="d-flex justify-content-center align-items-center vh-100">
            <button (click)="clearJamabandiPortalData()" pButton pRipple label="{{ 'Clear Details' | translate }}"
              class="p-button-secondary"></button>
          </div>
        </div>

      </div>
    </form>

    <div class="dashboardTable" *ngIf="landOwnerDetails.length > 0">

      <p-table #landOwnerDataTable [value]="landOwnerDetails" [rows]="10" [paginator]="true" [globalFilterFields]="[
          'Owner_Name',
          'Bhag',
          'Khewat',
          'khewat_area',
          'owner_hissa',
          'TotalArea',
          'Year',
          ]" [rowHover]="true" dataKey="uiqueId" (onRowSelect)="onRowSelect($event)"
        (onRowUnselect)="onRowUnselect($event)" [(selection)]="selectedLandOwnerDetails"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true" responsiveLayout="scroll">
        <ng-template pTemplate="caption">
          <div class="grid p-fluid mt-2 justify-content-between">
            <!-- Left side -->
            <div class="field col-12 md:col-5">
              <p class="pt-2 " [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{
                'Fetched Land Owner Details from Jamabandi Portal' }}</p>
                <!-- 'Land Detail from Jamabandi Portal' }}</p> -->
            </div>
            <!-- Middle section for buttons -->
            <div class="field col-12 md:col-4">
              <p class="pt-2 " [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{
                'Village Unit Measurement - ' }} {{ isBighaBiswa ? "Bigha Biswa" : "Kanal Marla" }}</p>
              <!-- <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
                class="p-button-help mx-1"></button>
              <button (click)="refreshTable()" pButton pRipple label="" icon="pi pi-refresh"
                class="p-button-info mx-1"></button>
              <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu> -->
            </div>
            <!-- Right side for search -->
            <div class="field col-12 md:col-3 align-items-center justify-content-end">
              <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text"
                  (input)="landOwnerDataTable.filterGlobal($any($event.target).value, 'contains')"
                  placeholder="{{'SEARCH'| translate}}" />
              </span>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th></th>
            <th>{{'S.No'| translate}}</th>
            <th>{{'KHEWAT'| translate}}</th>
            <th>{{'OWNER_NAME'| translate}}</th>
            <th>{{'BHAG'| translate}}</th>
            <th>{{'KHEWAT_AREA'| translate}}</th>
            <th>{{'OWNER_HISSA_IN_ACRES'| translate}}</th>
            <th>{{'TOTAL_APPLIED_AREA_IN_ACRES'| translate}}</th>
            <th>{{'FARMER_APPLIED_AREA_IN_ACRES'| translate}}</th>
            <th>{{'YEAR'| translate}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product let-expanded="expanded" let-i="rowIndex">
          <tr (click)="toggleRow(product)"
            [ngStyle]="{'background-color': (isOwnerAlreadyAppLand && product?.TotalArea == 0) ? '#dfdede' : 'transparent'}">
            <td>
              <p-tableRadioButton [value]="product"
                [disabled]="isOwnerAlreadyAppLand && product?.TotalAreaFarmer == 0"></p-tableRadioButton>
            </td>
            <td>{{ i + 1 }}</td>
            <td>{{product?.Khewat}}</td>
            <td>{{product?.Owner_Name}}</td>
            <td>{{product?.Bhag}}</td>
            <td>{{product?.khewat_area}}</td>
            <td>{{product?.owner_hissa | number:'0.3-3'}}</td>
            <td>{{product?.TotalArea | number:'0.3-3'}}</td>
            <td>{{product?.TotalAreaFarmer | number:'0.3-3'}}</td>
            <td>{{product?.Year}}</td>
          </tr>
        </ng-template>
      </p-table>


      <div class="multiple-land-card card" *ngIf="selectedLandOwnerDetails.length > 0">

        <p-table #landOwnerDetailsDataTable [value]="landDetailedInfo" [rows]="10" [paginator]="true"
          [globalFilterFields]="[
          'khatoni',
          'khewat',
          'killa',
          'must',
          'knl',
          'mrl',
          'period',
          ]" [rowHover]="true" dataKey="uiqueId" (onRowSelect)="onRowSelectLand($event)"
          (onRowUnselect)="onRowUnselectLand($event)" [(selection)]="selectedLandDetails"
          currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
          [showCurrentPageReport]="true" responsiveLayout="scroll">
          <ng-template pTemplate="caption">
            <div class="grid p-fluid mt-2 justify-content-between">
              <!-- Left side -->
              <div class="field col-12 md:col-6">
                <p class="pt-2 " [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">
                  {{
                  'Fetched Land Details from Jamabandi Portal' }}</p>
              </div>
              <!-- Middle section for buttons -->
              <div class="field col-0 md:col-0">

              </div>
              <!-- Right side for search -->
              <div class="field col-12 md:col-6 align-items-center justify-content-end">
                <span class="p-input-icon-left">
                  <i class="pi pi-search"></i>
                  <input pInputText type="text"
                    (input)="landOwnerDetailsDataTable.filterGlobal($any($event.target).value, 'contains')"
                    placeholder="{{'SEARCH'| translate}}" />
                </span>
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th></th>
              <th>{{'S.No'| translate}}</th>
              <th>{{'KHATONI'| translate}}</th>
              <th>{{'KHEWAT'| translate}}</th>
              <th>{{'MORABBA_NUMBER'| translate}}</th>
              <th>{{'KILLA_NO'| translate}}</th>
              <th>{{ (isBighaBiswa ? 'BIGHA' : 'KANALS') | translate }}</th>
              <th>{{ (isBighaBiswa ? 'BISWA' : 'MARLAS')| translate }}</th>
              <th>{{'YEAR'| translate}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-product let-expanded="expanded" let-i="rowIndex">
            <!-- <tr (click)="toggleRow(product)" [ngStyle]="{'background-color': (isOwnerAlreadyAppLand && product?.TotalArea == 0) ? '#dfdede' : 'transparent'}"> -->
            <tr (click)="toggleRowLand(product)">
              <td>
                <p-tableRadioButton [value]="product"></p-tableRadioButton>
              </td>
              <td>{{ i + 1 }}</td>
              <td>{{product?.khatoni}}</td>
              <td>{{product?.khewat}}</td>
              <td>{{product?.must}}</td>
              <td>{{product?.killa}}</td>
              <td>{{product?.knl}}</td>
              <td>{{product?.mrl}}</td>
              <td>{{product?.period}}</td>
            </tr>
          </ng-template>
        </p-table>
        <div *ngIf="landDetailedInfo.length > 0" class="">
          <form [formGroup]="jamabandiLandForm2">
            <div class="grid p-fluid mt-3">
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <input pInputText inputId="morabbaNumber" type="text" class="form-control readOnly"
                    [pKeyFilter]="blockSpace" [readOnly]="true" formControlName="morabbaNumber" autofocus=""
                    tabindex="1" [ngClass]="{ 'ng-invalid ng-dirty': submittedJambandi2 && f2.morabbaNumber.errors }" />
                  <div *ngIf="submittedJambandi2 && f2.morabbaNumber.errors" class="invalid-feedback">
                    <div *ngIf="f2.morabbaNumber.errors.required">{{'MORABBA_NUMBER_IS_REQUIRED'| translate}}</div>
                  </div>
                  <label for="morabbaNumber">{{'MORABBA_NUMBER'| translate}}</label>
                </span>
              </div>
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <input pInputText inputId="killaNumber" type="text" class="form-control readOnly"
                    formControlName="killaNumber" [readOnly]="true" [pKeyFilter]="blockSpace" autofocus="" tabindex="1"
                    [ngClass]="{ 'ng-invalid ng-dirty': submittedJambandi2 && f2.killaNumber.errors }" />
                  <div *ngIf="submittedJambandi2 && f2.killaNumber.errors" class="invalid-feedback">
                    <div *ngIf="f2.killaNumber.errors.required">{{'KILLA_NUMBER_IS_REQUIRED'| translate}}</div>
                  </div>
                  <label for="killaNumber">{{'KILLA_NUMBER'| translate}}</label>
                </span>
              </div>
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <input pInputText inputId="totalKanals" type="text" class="form-control readOnly"
                    formControlName="totalKanals" [readOnly]="true"
                    [ngClass]="{ 'ng-invalid ng-dirty': submittedJambandi2 && f2.totalKanals.errors }" />
                  <div *ngIf="submittedJambandi2 && f2.totalKanals.errors" class="invalid-feedback">
                    <div *ngIf="f2.totalKanals.errors.required">{{'TOTAL_AREA_KANALS_IS_REQUIRED'| translate}}</div>
                  </div>
                  <label for="totalKanals">{{ (isBighaBiswa ? 'TOTAL_AREA_BIGHA' : 'TOTAL_AREA_KANALS') | translate}}</label>
                </span>
              </div>
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <input pInputText inputId="totalMarlas" type="text" class="form-control readOnly"
                    formControlName="totalMarlas" [readOnly]="true"
                    [ngClass]="{ 'ng-invalid ng-dirty': submittedJambandi2 && f2.totalMarlas.errors }" />
                  <div *ngIf="submittedJambandi2 && f2.totalMarlas.errors" class="invalid-feedback">
                    <div *ngIf="f2.totalMarlas.errors.required">{{'TOTAL_AREA_MARLAS_IS_REQUIRED'| translate}}</div>
                    </div>
                    <!-- <label for="totalMarlas">{{ isBighaBiswa ? ('TOTAL_AREA_MARLAS' | translate) : ('TOTAL_AREA_BISWA' | translate) }}</label> -->
                  <label for="totalMarlas">{{ (isBighaBiswa ? 'TOTAL_AREA_BISWA' : 'TOTAL_AREA_MARLAS') | translate}}</label>
                </span>
              </div>

              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <input [readOnly]="true" pInputText id="totalArea" class="form-control readOnly" type="text"
                    formControlName="totalArea" autofocus="" tabindex="1"
                    [ngClass]="{ 'ng-invalid ng-dirty': submittedJambandi2 && f2.totalArea.errors }" />
                  <div *ngIf="submittedJambandi2 && f2.totalArea.errors" class="invalid-feedback">
                    <div *ngIf="f2.totalArea.errors.required">{{'TOTAL_AREA_IS_REQUIRED'| translate}}</div>
                    <!-- <div *ngIf="f2.totalArea.errors.max">{{'LAND_AREA_CANNOT_BE_GREATER_THAN'| translate}}{{
                      maxLandAreaToAddValidation | number:'0.3-3' }}</div> -->
                  </div>
                  <label for="totalArea">{{'TOTAL_AREA_IN_ACRE'| translate}}</label>
                </span>
              </div>
              
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <input [readOnly]="true" pInputText id="totalAppliedArea" class="form-control readOnly" type="text"
                    formControlName="totalAppliedArea" autofocus="" tabindex="1"
                    [ngClass]="{ 'ng-invalid ng-dirty': submittedJambandi2 && f2.totalAppliedArea.errors }" />
                  <div *ngIf="submittedJambandi2 && f2.totalAppliedArea.errors" class="invalid-feedback">
                    <div *ngIf="f2.totalAppliedArea.errors.required">{{'TOTAL_APPLIED_AREA_IS_REQUIRED'| translate}}</div>
                    <div *ngIf="f2.totalAppliedArea.errors.max">{{'LAND_AREA_CANNOT_BE_GREATER_THAN'| translate}}{{
                      maxLandAreaToAddValidation | number:'0.3-3' }}</div>
                  </div>
                  <label for="totalAppliedArea">{{'TOTAL_APPLIED_AREA_IN_ACRE'| translate}}</label>
                </span>
              </div>

              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <input [readOnly]="false" pInputText id="kanals" class="form-control" type="text"
                    formControlName="kanals" autofocus="" tabindex="1"
                    [ngClass]="{ 'ng-invalid ng-dirty': submittedJambandi2 && f2.kanals.errors }"
                    (keyup)="onKMBBChangeNew()" pKeyFilter="int"/>
                  <!-- <input [readOnly]="false" pInputText id="kanals" class="form-control" type="text"
                    formControlName="kanals" autofocus="" tabindex="1"
                    [ngClass]="{ 'ng-invalid ng-dirty': submittedJambandi2 && f2.kanals.errors }"
                    (keyup)="onKanalsChange()" maxlength="1" pattern="^([0-1]?[0-8])$" pKeyFilter="int"
                    oninput="if(!this.value.match('^[0-8][0-8]*$'))this.value='';" /> -->
                  <div *ngIf="submittedJambandi2 && f2.kanals.errors" class="invalid-feedback">
                    <div *ngIf="f2.kanals.errors.required">{{'KANNALS_IS_REQUIRED'| translate}}</div>
                    <div *ngIf="f2.kanals.errors.max">{{'KANAL_CANNOT_BE_GREATER_'| translate}} {{ f2.totalKanals.value }}</div>
                  </div>
                  <label for="kanals">{{ (isBighaBiswa ? 'AREA_IN_BIGHA' : 'AREA_IN_KANALS') | translate}}</label>
                </span>
              </div>
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <input maxlength="2" pKeyFilter="int" pInputText id="marlas" class="form-control" type="text"
                    formControlName="marlas" autofocus="" tabindex="1" [readOnly]="false"
                    [ngClass]="{ 'ng-invalid ng-dirty': submittedJambandi2 && f2.marlas.errors }"
                    (keyup)="onKMBBChangeNew()"/>
                  <!-- <input maxlength="2" pKeyFilter="int" pInputText id="marlas" class="form-control" type="text"
                    formControlName="marlas" autofocus="" tabindex="1" [readOnly]="false"
                    [ngClass]="{ 'ng-invalid ng-dirty': submittedJambandi2 && f2.marlas.errors }"
                    (keyup)="onMarlasChange()" oninput="if(!this.value.match('^([0-9]|1[0-9])$'))this.value='';" /> -->
                  <div *ngIf="submittedJambandi2 && f2.marlas.errors" class="invalid-feedback">
                    <div *ngIf="f2.marlas.errors.required">{{'MARLAS_IS_REQUIRED'| translate}}</div>
                    <div *ngIf="f2.marlas.errors.max">{{'MARLAS_SHOULD_NOT_BE_GREATER_'| translate}} {{ f2.totalMarlas.value }}</div>
                  </div>
                  <label for="marlas">{{ (isBighaBiswa ? 'AREA_IN_BISWA' : 'AREA_IN_MARLAS') | translate}}</label>
                </span>
              </div>

              <!-- <div class="field col-12 md:col-3">
                <span class="p-float-label">
                  <input pInputText inputId="landArea" type="text" class="form-control" [pKeyFilter]="blockSpace"
                    [readOnly]="landDetailsfromJamabandi.length > 0" formControlName="landArea" autofocus=""
                    tabindex="1" [ngClass]="{ 'ng-invalid ng-dirty': submittedJambandi2 && f2.landArea.errors }" />
                  <div *ngIf="submittedJambandi2 && f2.landArea.errors" class="invalid-feedback">
                    <div *ngIf="f2.landArea.errors.required">{{'LAND_AREA_IS_REQUIRED'| translate}}</div>
                    <div *ngIf="f2.landArea.errors.max">{{'LAND_AREA_CANNOT_BE_GREATER_THAN'| translate}}{{ maxLandAreaToAddValidation }}</div>
                  </div>
                  <label for="landArea">{{'LAND_AREA_(ACRES)'| translate}}</label>
                </span>
              </div> -->

              <div class="field col-12 md:col-3">
                <span class="p-float-label">
                  <!-- <p-treeSelect [propagateSelectionDown]="false" formControlName="cropType" [(ngModel)]="selectedNodes1" [options]="nodes2" appendTo="body"
                    [metaKeySelection]="true" selectionMode="checkbox"
                    placeholder="{{'SELECT_CROP_TYPE'| translate}}"></p-treeSelect> -->

                  <p-multiSelect [showToggleAll]="false" [options]="cropMergeList" formControlName="cropType"
                    [disabled]="landDetailsfromJamabandi.length > 0" [maxSelectedLabels]="4"
                    [selectedItemsLabel]="'{0} items selected'" placeholder="{{'SELECT_CROP_TYPE'| translate}}"
                    [(ngModel)]="selectedNodes1" optionLabel="label" [virtualScroll]="true" [virtualScrollItemSize]="30"
                    appendTo="body" (onChange)="onCropSelect($event)"></p-multiSelect>

                  <div *ngIf="selectedNodes1?.length > 4" class="invalid-feedback">
                    <div>{{'MAXIMUM_4_CROP_IS_ALLOWED_YOU_SELECTED'| translate}} {{ selectedNodes1?.length }}</div>
                  </div>
                  <div *ngIf="submittedJambandi2 && f2.cropType.errors" class="invalid-feedback">
                    <div *ngIf="f2.cropType.errors.required">{{'CROP_TYPE_IS_REQUIRED'| translate}}</div>
                  </div>
                </span>
              </div>

              <!-- <div class="field col-12 md:col-3"> -->
              <div class="d-flex justify-content-center align-items-center vh-100 mx-5 mt-2">
                <!-- <button (click)="onClickGetKhewat()" pButton pRipple label="{{ 'Get Land Area' | translate }}"
                    [disabled]="landDetailsfromJamabandi.length > 0" class="p-button-success"></button> -->
                <button class="mt-1" (click)="onClickAddLand()" pButton pRipple
                  label="{{ 'ADD_LAND_DETAILS' | translate }}" [disabled]="landDetailsfromJamabandi.length > 0"
                  class="p-button-success"></button>
              </div>
              <div class="d-flex justify-content-center align-items-center vh-100 mx-5 mt-2">
                <button class="mt-1 pt-1 mx-5" (click)="onClickResetLandDetails()" pButton pRipple
                  label="{{ 'RESET' | translate }}" [disabled]="landDetailsfromJamabandi.length > 0"
                  class="p-button-warning"></button>
              </div>
              <!-- </div> -->
            </div>
          </form>

          <hr>

          <div *ngIf="landDetailsfromJamabandi.length > 0" class="p-fluid p-formgrid grid justify-content-center">
            <div class="field col-12 md:col-6 justify-content-center">
              <p class="area-text">AREA: <label>{{ landDetailsfromJamabandi[0].area }}</label></p>
              <!-- <label htmlFor="">{{'AREA'| translate}}</label>
              <div class="grid-item">
                <p-dropdown [(ngModel)]="selectedLandArea" (onChange)="onSelectLandArea()"
                  [options]="landDetailsfromJamabandi" appendTo="body" placeholder="{{ 'Select'| translate }}"
                  optionLabel="area"></p-dropdown>
              </div> -->
            </div>

            <div class="field col-12 md:col-2">
              <div class="d-flex justify-content-center align-items-center vh-100 mt-2">
                <button (click)="onClickAddDetail()" pButton pRipple label="{{ 'Add Land' | translate }}"
                  class="p-button-success"></button>
              </div>
            </div>

            <div class="field col-12 md:col-2">
              <div class="d-flex justify-content-center align-items-center vh-100 mt-2">
                <button (click)="onClickClearDetail()" pButton pRipple label="{{ 'Clear Detail' | translate }}"
                  class="p-button-secondary"></button>
              </div>
            </div>
          </div>
        </div>

        <p-table *ngIf="addedLandDetails.length > 0" class="mainTable1 mt-2 card" [value]="addedLandDetails" [rows]="10"
          [paginator]="false" [rowHover]="true" responsiveLayout="scroll" [showCurrentPageReport]="false">
          <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
              <h5 style="color:rgb(97, 27, 27); font-size: '1.0rem'; font-weight: bold;" class="px-3"><b>{{
                  ''| translate}}</b></h5>

            </div>
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th>{{'MORABBA_NUMBER'| translate}}</th>
              <th>{{'KILLA_NUMBER'| translate}}</th>
              <th>{{ (isBighaBiswa ? 'BIGHA' : 'KANALS') | translate}}</th>
              <th>{{ (isBighaBiswa ? 'BISWA' : 'MARLAS') | translate}}</th>
              <th>{{'AREA'| translate}}</th>
              <th>{{ (isBighaBiswa ? 'APPLIED_BIGHA' : 'APPLIED_KANALS') | translate}}</th>
              <th>{{ (isBighaBiswa ? 'APPLIED_BISWA' : 'APPLIED_MARLAS')| translate}}</th>
              <th>{{'APPLIED_AREA'| translate}}</th>
              <th>{{'CROP_NAME'| translate}}</th>
              <th>{{'ACTION'| translate}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-product let-i="rowIndex" let-columns="columns">
            <tr>
              <td>{{product?.morbno}}</td>
              <td>{{product?.killano}}</td>
              <td>{{product?.kanal}}</td>
              <td>{{product?.marla}}</td>
              <td>{{product?.totalArea}}</td>
              <td>{{product?.appliedKanal}}</td>
              <td>{{product?.appliedMarla}}</td>
              <td>{{product?.appliedArea}}</td>
              <td>{{product?.cropName}}</td>
              <td>
                <div>
                  <button pButton pRipple icon="pi pi-trash"
                    class="p-button-rounded p-button-accent p-button-danger p-button-rounded"
                    (click)="deleteLand(product, i)"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <!-- <ng-template pTemplate="footer"> -->
            <!-- </ng-template> -->
            
          </p-table>
          <div *ngIf="addedLandDetails.length > 0" class="conatiner">
            <form [formGroup]="consentForm">
                <div class="field-checkbox consent-checkbox col-12 md:col-12">
                  <p-checkbox formControlName="consent" [binary]="true"
                    [ngClass]="{ 'ng-invalid ng-dirty': finalLandSubmitClicked && consentController.consent.value !== true }"></p-checkbox>
                  <label for="consent">{{'LAND_CONSENT'| translate}}</label>
                  <!-- <div *ngIf="finalLandSubmitClicked && consentController.consent.value !== true" class="invalid-feedback">
                    <div>{{'CONSENT_IS_REQUIRED'| translate}}</div>
                  </div> -->
                </div>
            </form>
            <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
              <div class="field md:col-6 col-12">
                <div class="flex">
                  <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true" #farmerLeaseDocUpload
                    (uploadHandler)="onUploadFard($event, 'fard_Path', farmerLeaseDocUpload)" name="myfile[]"
                    mode="basic" [maxFileSize]="5000000" chooseLabel="{{'UPLOAD_FARD_DOCUMENTS'| translate}}"
                    [auto]="true">
                  </p-fileUpload>
                  <p-image *ngIf="fardPath != null" [src]="fardPath" alt="Image" width="60" class="ml-2"
                    iconPos="left"></p-image>
                </div>
              </div>

              <div class="mt-2 p-fluid p-formgrid justify-content-center">
                <button (click)="onFinalSubmitClick()" pButton pRipple label="{{ 'SUBMIT' | translate }}"
                  class="p-button-success"></button>
              </div>
            </div>
          </div>
      </div>
    </div>

  </ng-template>

  <ng-template pTemplate="footer">
    <button pButton pRipple label="{{'CANCEL'| translate}}" icon="pi pi-times" class="p-button-text"
      (click)="hideDialogJamaBandi()"></button>
    <!-- <button pButton pRipple label="{{'SAVE' | translate}}" icon="pi pi-check" class="p-button-text"
      (click)="onSubmitJamabandi()"></button> -->
  </ng-template>
</p-dialog>